import React from 'react';
import { IWorkplaces } from 'module/workplaces/interface/WorkplacesInterface';
import { useCalendarView } from 'core/hooks/useCalendarView';
import './ScheduleEventsHeader.style.scss';

interface ScheduleEventsHeaderProps {
    workplacesData: IWorkplaces;
    workplaceId: number;
    onSwitchCalendarType?: (type: 'schedule' | 'request' | 'event') => void;
    onAddShift?: () => void;
    onPublish?: () => void;
    canManageShifts?: boolean;
}

const ScheduleEventsHeader: React.FC<ScheduleEventsHeaderProps> = ({
    workplacesData: _workplacesData,
    workplaceId: _workplaceId,
    onSwitchCalendarType: _onSwitchCalendarType,
    onAddShift,
    onPublish,
    canManageShifts = true,
}) => {
    const { calendarView, setCalendarView } = useCalendarView();

    const handleAddShift = () => {
        if (onAddShift) {
            onAddShift();
        }
    };

    const handlePublish = () => {
        if (onPublish) {
            onPublish();
        }
    };

    return (
        <div className="customHeader EventsHeader">
            <div className="customHeaderTop">
                <div className="workplaceContainer"></div>
                <div className="centerControls">
                    <div className="viewToggleContainer">
                        <button
                            className={`viewToggle ${calendarView === 'day' ? 'active' : ''}`}
                            onClick={() => setCalendarView('day')}
                        >
                            Day
                        </button>
                        <button
                            className={`viewToggle ${calendarView === 'week' ? 'active' : ''}`}
                            onClick={() => setCalendarView('week')}
                        >
                            Week
                        </button>
                    </div>
                </div>
                <div className="rightControls">
                    {/* <button 
                        className="publishButton" 
                        onClick={handlePublish}
                        disabled={!canManageShifts}
                        style={{ opacity: canManageShifts ? 1 : 0.5, cursor: canManageShifts ? 'pointer' : 'not-allowed' }}
                    >
                        Publish
                    </button> */}
                    {canManageShifts && (
                        <div className="addButtonContainer">
                            <button 
                                className="addEventButton" 
                                onClick={handleAddShift}
                            >
                                Add
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <div className="customHeaderMiddle"></div>
        </div>
    );
};

export default ScheduleEventsHeader;
